(() => {
  if (window.SSFlyingProductReady) return;
  window.SSFlyingProductReady = true;

  const REDUCED_MOTION = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  function getCartTarget() {
    return (
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.nh-cart') ||
      document.querySelector('.ss-hb-icons__cart') ||
      document.querySelector('a[href*="/cart"]') ||
      document.querySelector('[class*="cart-icon"]')
    );
  }

  function getProductImage(button) {
    const productArea = button.closest(
      [
        '[id^="SSProduct-"]',
        '.card-wrapper',
        '.product-card-wrapper',
        '.card',
        '.ss-product-card',
        '[class*="product-card"]',
        '[data-product-card]'
      ].join(',')
    );

    const searchArea = productArea || document;

    const images = Array.from(
      searchArea.querySelectorAll(
        'img:not([aria-hidden="true"]):not([role="presentation"])'
      )
    );

    return (
      images.find((image) => {
        const rect = image.getBoundingClientRect();
        const style = getComputedStyle(image);

        return (
          rect.width > 60 &&
          rect.height > 60 &&
          image.complete &&
          image.naturalWidth > 0 &&
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          Number(style.opacity) !== 0
        );
      }) ||
      document.querySelector(
        [
          '[id^="SSProduct-"] .ss-gallery__media.is-active img',
          '[id^="SSProduct-"] .ss-gallery__main img',
          '[id^="SSProduct-"] .ss-gallery img',
          '.product-card-wrapper .card__media img',
          '.card-wrapper .card__media img'
        ].join(',')
      ) ||
      null
    );
  }

  function cartBounce(cart) {
    cart.classList.remove('ss-fly-cart-bounce');
    void cart.offsetWidth;
    cart.classList.add('ss-fly-cart-bounce');

    window.setTimeout(() => {
      cart.classList.remove('ss-fly-cart-bounce');
    }, 650);
  }

  async function syncCustomHeaderCart() {
    try {
      const cartURL =
        (window.routes?.cart_url || '/cart').replace(/\/$/, '') + '.js';
      const response = await fetch(cartURL, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      const count = String(cart.item_count || 0);

      document
        .querySelectorAll(
          '.nh-cart > span, .ss-hb-cart-count, .ss-icons__item[href*="/cart"] span'
        )
        .forEach((element) => {
          element.textContent = count;
          element.hidden = false;
        });

      const target = getCartTarget();
      if (target) cartBounce(target);
    } catch (error) {
      console.warn('[Header cart sync]', error);
    }
  }

  function scheduleHeaderSync() {
    window.setTimeout(syncCustomHeaderCart, 350);
    window.setTimeout(syncCustomHeaderCart, 900);
  }

  function createSparkles(x, y) {
    const colours = ['#171717', '#e92836', '#d7a56d', '#ffffff'];

    for (let index = 0; index < 7; index += 1) {
      const particle = document.createElement('span');
      const angle = (Math.PI * 2 * index) / 7;
      const distance = 18 + Math.random() * 18;

      particle.className = 'ss-cart-sparkle';
      particle.style.left = `${x}px`;
      particle.style.top = `${y}px`;
      particle.style.background = colours[index % colours.length];

      document.body.appendChild(particle);

      particle
        .animate(
          [
            {
              opacity: 1,
              transform: 'translate(-50%, -50%) scale(1)'
            },
            {
              opacity: 0,
              transform: `translate(
                calc(-50% + ${Math.cos(angle) * distance}px),
                calc(-50% + ${Math.sin(angle) * distance}px)
              ) scale(0)`
            }
          ],
          {
            duration: 480,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'forwards'
          }
        )
        .finished.finally(() => particle.remove());
    }
  }

  function flyProduct(button) {
    const cart = getCartTarget();
    const image = getProductImage(button);

    if (!cart || !image) {
      if (cart) cartBounce(cart);
      return;
    }

    if (REDUCED_MOTION.matches) {
      cartBounce(cart);
      return;
    }

    const imageRect = image.getBoundingClientRect();
    const cartRect = cart.getBoundingClientRect();

    if (
      imageRect.width < 20 ||
      imageRect.height < 20 ||
      cartRect.width < 5 ||
      cartRect.height < 5
    ) {
      cartBounce(cart);
      return;
    }

    const startX = imageRect.left;
    const startY = imageRect.top;
    const endX = cartRect.left + cartRect.width / 2;
    const endY = cartRect.top + cartRect.height / 2;

    const clone = image.cloneNode(true);
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');
    clone.removeAttribute('loading');
    clone.src = image.currentSrc || image.src;
    clone.setAttribute('aria-hidden', 'true');
    clone.className = 'ss-flying-product-image';

    Object.assign(clone.style, {
      position: 'fixed',
      zIndex: '2147483000',
      pointerEvents: 'none',
      margin: '0',
      left: `${startX}px`,
      top: `${startY}px`,
      width: `${imageRect.width}px`,
      height: `${imageRect.height}px`,
      objectFit: getComputedStyle(image).objectFit || 'contain',
      opacity: '1',
      visibility: 'visible',
      display: 'block',
      background: '#ffffff',
      borderRadius: getComputedStyle(image).borderRadius,
      transformOrigin: 'center',
      willChange: 'transform, opacity, filter'
    });

    document.body.appendChild(clone);

    const deltaX = endX - (imageRect.left + imageRect.width / 2);
    const deltaY = endY - (imageRect.top + imageRect.height / 2);
    const curveX = deltaX * 0.48;
    const curveY = Math.min(-110, deltaY * 0.25 - 70);

    const animation = clone.animate(
      [
        {
          transform: 'translate(0, 0) scale(1)',
          opacity: 0.95,
          filter: 'drop-shadow(0 12px 18px rgba(0,0,0,.18))'
        },
        {
          transform: `translate(${curveX}px, ${curveY}px) scale(.48) rotate(-4deg)`,
          opacity: 0.9,
          offset: 0.55,
          filter: 'drop-shadow(0 18px 22px rgba(0,0,0,.22))'
        },
        {
          transform: `translate(${deltaX}px, ${deltaY}px) scale(.06) rotate(8deg)`,
          opacity: 0.15,
          filter: 'drop-shadow(0 0 0 rgba(0,0,0,0))'
        }
      ],
      {
        duration: 1000,
        easing: 'cubic-bezier(0.22, 0.8, 0.26, 1)',
        fill: 'forwards'
      }
    );

    animation.finished
      .then(() => {
        clone.remove();
        cartBounce(cart);
        createSparkles(endX, endY);
      })
      .catch(() => clone.remove());
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(
        [
          '.ss-button--cart',
          'button[type="submit"][name="add"]',
          'button[name="add"]',
          '[data-ajax-add-button]'
        ].join(',')
      );

      if (!button || button.disabled || button.hidden) return;
      if (button.closest('cart-drawer, cart-notification')) return;

      flyProduct(button);
      scheduleHeaderSync();
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest('.ss-ajax-quantity button')) return;
      scheduleHeaderSync();
    },
    true
  );

  const style = document.createElement('style');
  style.textContent = `
    #cart-icon-bubble.ss-fly-cart-bounce,
    .ss-fly-cart-bounce {
      animation: ssFlyCartBounce 620ms cubic-bezier(0.22, 1, 0.36, 1);
    }

    .ss-cart-sparkle {
      position: fixed;
      z-index: 2147483001;
      width: 7px;
      height: 7px;
      border: 1px solid rgba(0, 0, 0, 0.14);
      border-radius: 50%;
      pointer-events: none;
    }

    @keyframes ssFlyCartBounce {
      0%, 100% {
        transform: scale(1);
      }

      35% {
        transform: scale(1.28) rotate(-7deg);
      }

      58% {
        transform: scale(0.9) rotate(4deg);
      }

      78% {
        transform: scale(1.1) rotate(-2deg);
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .ss-flying-product-image,
      .ss-cart-sparkle {
        display: none !important;
      }

      .ss-fly-cart-bounce {
        animation: none !important;
      }
    }
  `;

  document.head.appendChild(style);
})();
